import { takeEvery, put, select, call, fork } from "redux-saga/effects";
import { addTimingMeasureInstructionsToAction } from "utils/timing";
import * as actionTypes from "constants/actionTypes";
import { selectAccountId } from "reducers/account/meta";
import { selectAccountGoals } from "reducers/account/goals";
import * as firebase from "sagas/firebase/lib";
import { throttleBy } from "utils/sagas";

export function* replaceAccountGoals(data) {
  yield put(
    addTimingMeasureInstructionsToAction(
      {
        type: actionTypes.REPLACE_ACCOUNT_GOALS,
        payload: data || {}
      },
      actionTypes.SYNC_ACCOUNT_WITH_FIREBASE
    )
  );
}

function* flushGoalToFirebase(action) {
  const { goalId } = action.payload;

  const accountId = yield select(selectAccountId);
  const goal = (yield select(selectAccountGoals))[goalId];

  if (goal) {
    yield call(firebase.set, `accounts/${accountId}/goals/${goalId}`, goal);
  } else {
    yield call(firebase.remove, [`accounts/${accountId}/goals/${goalId}`]);
  }
}

export function* createGoalInFirebase(goal) {
  const accountId = yield select(selectAccountId);
  return yield call(firebase.push, { [`accounts/${accountId}/goals`]: goal });
}

export default function* goals() {
  yield takeEvery(actionTypes.CREATE_GOAL_IN_FIREBASE, createGoalInFirebase);

  yield fork(
    throttleBy,
    "goalId",
    500,
    actionTypes.FLUSH_GOAL_TO_FIREBASE,
    flushGoalToFirebase
  );
}
